import React from 'react';
import './PrivacyPolicy.scss';
import {useTranslation} from 'react-i18next';

const PrivacyPolicy = () => {
  const {t} = useTranslation();
  const updatedDate = '2024-04-10';
  return (
    <div className={'privacyPolicy'}>
      <h1>{t('PrivacyPolicy.title')}</h1>

      <h5>
        {t('PrivacyPolicy.updated')} {updatedDate}
      </h5>

      <p>{t('PrivacyPolicy.p1')}</p>

      <h3> {t('PrivacyPolicy.p2')}</h3>

      <h4>{t('PrivacyPolicy.p3')}</h4>
      <ul>
        <li>{t('PrivacyPolicy.p4')}</li>
        <li>{t('PrivacyPolicy.p5')}</li>
        <li> {t('PrivacyPolicy.p6')}</li>
        <li>{t('PrivacyPolicy.p7')}</li>
        <li>{t('PrivacyPolicy.p8')}</li>
        <li>{t('PrivacyPolicy.p9')}</li>
        <li>{t('PrivacyPolicy.p10')}</li>
        <li>{t('PrivacyPolicy.p11')}</li>
        <li>{t('PrivacyPolicy.p12')}</li>
        <li>{t('PrivacyPolicy.p13')}</li>
        <li> {t('PrivacyPolicy.p14')}</li>
        <li> {t('PrivacyPolicy.p15')}</li>
      </ul>

      <h3>{t('PrivacyPolicy.p16')}</h3>

      <h4>{t('PrivacyPolicy.p17')}</h4>
      <ul>
        <li>{t('PrivacyPolicy.p18')}</li>
        <li>{t('PrivacyPolicy.p19')}</li>
        <li>{t('PrivacyPolicy.p20')}</li>
      </ul>

      <h4>{t('PrivacyPolicy.p21')}</h4>
      <ul>
        <li>{t('PrivacyPolicy.p22')}</li>
        <li>{t('PrivacyPolicy.p23')}</li>
      </ul>

      <h3>{t('PrivacyPolicy.p24')}</h3>

      <p>{t('PrivacyPolicy.p25')}</p>

      <h3>{t('PrivacyPolicy.p26')}</h3>

      <p>{t('PrivacyPolicy.p27')}</p>

      <h3>{t('PrivacyPolicy.p28')}</h3>

      <p>{t('PrivacyPolicy.p29')}</p>

      <h3> {t('PrivacyPolicy.p30')}</h3>

      <p>{t('PrivacyPolicy.p31')}</p>

      <h3> {t('PrivacyPolicy.p32')}</h3>

      <h4> {t('PrivacyPolicy.p33')}</h4>
      <ul>
        <li>{t('PrivacyPolicy.p34')}</li>
        <li>{t('PrivacyPolicy.p35')}</li>
        <li>{t('PrivacyPolicy.p36')}</li>
        <li> {t('PrivacyPolicy.p37')}</li>
        <li> {t('PrivacyPolicy.p38')} </li>
        <li> {t('PrivacyPolicy.p39')}</li>
      </ul>

      <h3> {t('PrivacyPolicy.p40')}</h3>

      <p>{t('PrivacyPolicy.p41')}</p>

      <h3> {t('PrivacyPolicy.p42')}</h3>
      <p>{t('PrivacyPolicy.p43')}</p>

      <h3> {t('PrivacyPolicy.p44')}</h3>
      <p>{t('PrivacyPolicy.p45')}</p>

      <h3> {t('PrivacyPolicy.p46')}</h3>

      <p>{t('PrivacyPolicy.p47')}</p>

      <h3> {t('PrivacyPolicy.p48')}</h3>
      <p>{t('PrivacyPolicy.p49')}</p>

      <h3> {t('PrivacyPolicy.p50')}</h3>

      <p> {t('PrivacyPolicy.p51')}</p>

      <h3> {t('PrivacyPolicy.p52')}</h3>

      <p> {t('PrivacyPolicy.p53')}</p>
      <h3> {t('PrivacyPolicy.p54')}</h3>
      <p> {t('PrivacyPolicy.p55')}</p>
      <h3> {t('PrivacyPolicy.p56')}</h3>
      <p> {t('PrivacyPolicy.p57')}</p>
      <h3> {t('PrivacyPolicy.p58')}</h3>
      <p>{t('PrivacyPolicy.p59')}</p>
      <h3> {t('PrivacyPolicy.p60')}</h3>
      <p> {t('PrivacyPolicy.p61')}</p>
      <h3> {t('PrivacyPolicy.p62')}</h3>
      <p> {t('PrivacyPolicy.p63')}</p>
      <h3> {t('PrivacyPolicy.p64')}</h3>
      <p> {t('PrivacyPolicy.p65')}</p>
      <h3> {t('PrivacyPolicy.p66')}</h3>
      <p> {t('PrivacyPolicy.p67')}</p>
      <h3> {t('PrivacyPolicy.p68')}</h3>
      <p> {t('PrivacyPolicy.p69')}</p>
      <h3> {t('PrivacyPolicy.p70')}</h3>
      <p> {t('PrivacyPolicy.p71')}</p>
      <h3> {t('PrivacyPolicy.p72')}</h3>
      <p> {t('PrivacyPolicy.p73')}</p>
      <h3> {t('PrivacyPolicy.p74')}</h3>
      <p> {t('PrivacyPolicy.p75')}</p>
      <h3> {t('PrivacyPolicy.p76')}</h3>
      <h4 className={'custom-heading'}> {t('PrivacyPolicy.p77')}</h4>
      <ul className={'custom-icons'}>
        <li> {t('PrivacyPolicy.p78')}</li>
        <li> {t('PrivacyPolicy.p79')}</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
